// Copyright ©️ 2026 eVolve MEP, LLC

import { ActionIcon, Button } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';

type Props = {
  onClick: () => void;
  /** Renders only the arrow, for the collapsed navbar. */
  iconOnly?: boolean;
  className?: string;
  inert?: boolean;
};

const ARIA_LABEL = 'Back to main navigation';

export const SubNavBackButton = ({ onClick, iconOnly, className, inert }: Props) =>
  iconOnly ? (
    <ActionIcon
      aria-label={ARIA_LABEL}
      className={className}
      inert={inert}
      onClick={onClick}
      size="input-xs"
      variant="outline"
      style={{
        '--ai-bg': 'transparent',
        '--ai-hover': 'var(--mantine-color-app-shell-gray-7)',
        '--ai-color': 'var(--mantine-color-app-shell-gray-5)',
        '--ai-bd': '1px solid var(--mantine-color-app-shell-gray-5)',
      }}
    >
      <EvolveIcon icon="ArrowLeft" size="xs" />
    </ActionIcon>
  ) : (
    <Button
      aria-label={ARIA_LABEL}
      className={className}
      inert={inert}
      onClick={onClick}
      size="xs"
      variant="outline"
      fw={500}
      w="fit-content"
      leftSection={<EvolveIcon icon="ArrowLeft" size="xs" color="app-shell-gray.5" />}
      style={{
        '--button-bg': 'transparent',
        '--button-hover': 'var(--mantine-color-app-shell-gray-7)',
        '--button-color': 'var(--mantine-color-app-shell-gray-0)',
        '--button-bd': '1px solid var(--mantine-color-app-shell-gray-5)',
      }}
    >
      Back
    </Button>
  );
